import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from '../model/user';
import { Observable } from 'rxjs';
import { ResponseObj } from '../model/responseObj';
import { environment } from 'src/environments/environment';
import { Login } from '../model/login';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }
  userLogin(userModel: Login): Observable<any> {
    return this.http.post(environment.endpoints.login, userModel, { withCredentials: true });
  }

  verifyMfa(challengeId: string, otp: string, rememberDevice = false, trustedDeviceDays = 7): Observable<any> {
    return this.http.post(environment.endpoints.mfaVerify,
      { challengeId, otp, rememberDevice, trustedDeviceDays },
      { withCredentials: true });
  }

  resendMfa(challengeId: string): Observable<any> {
    return this.http.post(environment.endpoints.mfaResend, { challengeId });
  }

  autoLogin({ email, hash }): Observable<any> {
    return this.http.post(environment.endpoints.autologin, { email, hash });
  }

  logout() {
    return this.http.post(environment.endpoints.logout, null);

  }
}
